import { handleActions } from "redux-actions";

import { removeById, updateById } from "utils";

const floorplanReducer = handleActions(
  {
    FLOORPLAN_ALL_GET: {
      PENDING: ({ floorplans }) => ({
        floorplans,
      }),
      FULFILLED: (_, { payload }) => ({
        floorplans: payload.floorplans,
      }),
    },
    FLOORPLAN_GET: {
      PENDING: () => ({
        floorplan: {},
        floorplanSpaces: [],
      }),
      FULFILLED: (_, { payload }) => ({
        floorplan: payload.floorplan,
        floorplanSpaces: payload.floorplan.floorplanSpaces,
      }),
    },
    FLOORPLAN_CREATE: {
      PENDING: (state) => ({
        floorplans: state.floorplans,
      }),
      FULFILLED: ({ floorplans }, { payload }) => ({
        floorplans: [...floorplans, payload.floorplan],
      }),
    },
    FLOORPLAN_DELETE: {
      FULFILLED: ({ floorplans }, { meta }) => ({
        floorplans: removeById(floorplans, meta.floorplanID),
      }),
    },
    FLOORPLAN_UPDATE: {
      PENDING: ({ floorplans }) => ({
        floorplans,
      }),
      FULFILLED: ({ floorplans }, { payload }) => ({
        floorplans: updateById(floorplans, payload.floorplan),
      }),
    },
    FLOORPLAN_COORDS_ADD: ({ clickedCoords }, { meta }) => ({
      clickedCoords: [...clickedCoords, meta.coordinates],
    }),
    FLOORPLAN_COORDS_CLEAR: () => ({
      clickedCoords: [],
    }),
  },
  {},
  { namespace: "_" }
);

export default floorplanReducer;
